module.exports = __webpack_public_path__ + "static/media/cda1024s2.5378f4c5.png";